import { z } from "zod";

// Doors (and anything tracked) loaded onto a truck for a job: out of the yard
// but not yet used or back. The yard scans a door out for a job; the tech's
// "found & done" consumes it from the truck (not the yard again); a dry run
// brings it back with a scan. Written by functions only.

export const StockLoadSchema = z.object({
  jobId: z.string(),
  jobTitle: z.string().default(""),
  itemId: z.string(),
  itemName: z.string().default(""),
  sku: z.string().default(""),
  quantity: z.number().int().positive(),
  /** Used at the job (came off the truck into the work). */
  usedQty: z.number().int().min(0).default(0),
  /** Scanned back into the yard. */
  returnedQty: z.number().int().min(0).default(0),
  status: z.enum(["loaded", "used", "returned"]).default("loaded"),
  note: z.string().max(500).default(""),
  loadedByUid: z.string(),
  loadedByName: z.string().default(""),
  loadedAt: z.number(),
  updatedAt: z.number(),
});
export type StockLoad = z.infer<typeof StockLoadSchema>;

/** Still on the truck. */
export const loadRemaining = (l: Pick<StockLoad, "quantity" | "usedQty" | "returnedQty">) => Math.max(0, l.quantity - l.usedQty - l.returnedQty);
